import { SECTORS, formatGs, sectorMeta } from "../../data/store";
import { FAMILIES } from "../../data/brandColors";
import { Thumb } from "./SimpleManager";

const sectorOpts = SECTORS.map((s) => ({ value: s.key, label: s.label }));
const SectorPill = ({ s }) => { const m = sectorMeta(s); return <span className="px-2 py-0.5 rounded-full text-[11px] font-bold" style={{ background: m.bg, color: m.text }}>{m.label}</span>; };

export const PROMOS_CONFIG = {
  name: "promotions", title: "Promociones destacadas", subtitle: "promociones (las activas se muestran en la tienda)", singular: "promoción",
  empty: { title: "", description: "", badge: "Oferta", product_code: "", price: "", old_price: "", image_url: "", active: true, valid_until: "" },
  numeric: ["price", "old_price"],
  fields: [
    { key: "title", label: "Título", required: true, full: true },
    { key: "description", label: "Descripción", type: "textarea" },
    { key: "badge", label: "Etiqueta", placeholder: "Oferta de la semana" },
    { key: "product_code", label: "Código de producto (opcional)", placeholder: "SW-INM-01" },
    { key: "price", label: "Precio promo (₲)", type: "number" },
    { key: "old_price", label: "Precio anterior (₲)", type: "number" },
    { key: "valid_until", label: "Válido hasta (texto)", placeholder: "30/06" },
    { key: "active", label: "Activa (visible en la tienda)", type: "checkbox" },
    { key: "image_url", label: "Imagen", type: "image" },
  ],
  columns: [
    { key: "image_url", label: "", render: (it) => <Thumb src={it.image_url} /> },
    { key: "title", label: "Promoción", render: (it) => (<div><div className="font-semibold text-gray-900">{it.title}</div><div className="text-xs text-gray-400">{it.badge}{it.product_code ? ` · ${it.product_code}` : ""}</div></div>) },
    { key: "price", label: "Precio", right: true, render: (it) => it.price ? <span className="font-bold text-[#E02424]">{formatGs(it.price)}</span> : <span className="text-gray-400">—</span> },
    { key: "active", label: "Estado", hide: true, render: (it) => <span data-testid={`promo-status-${it.id}`} className={`px-2 py-0.5 rounded-full text-[11px] font-bold ${it.active ? "bg-green-50 text-green-700" : "bg-gray-100 text-gray-500"}`}>{it.active ? "Activa" : "Inactiva"}</span> },
  ],
};

export const GALLERY_CONFIG = {
  name: "gallery", title: "Galería de trabajos", subtitle: "fotos de obras y proyectos", singular: "trabajo",
  empty: { title: "", description: "", sector: "inmobiliario", image_url: "", featured: false },
  fields: [
    { key: "title", label: "Título", required: true, full: true },
    { key: "description", label: "Descripción", type: "textarea" },
    { key: "sector", label: "Sector", type: "select", options: sectorOpts },
    { key: "featured", label: "Destacado (foto grande)", type: "checkbox" },
    { key: "image_url", label: "Foto del trabajo", type: "image" },
  ],
  columns: [
    { key: "image_url", label: "", render: (it) => <Thumb src={it.image_url} /> },
    { key: "title", label: "Trabajo", render: (it) => (<div><div className="font-semibold text-gray-900">{it.title}</div><div className="text-xs text-gray-400 line-clamp-1">{it.description}</div></div>) },
    { key: "sector", label: "Sector", hide: true, render: (it) => <SectorPill s={it.sector} /> },
    { key: "featured", label: "Destacado", right: true, render: (it) => it.featured ? "Sí" : "—" },
  ],
};

export const COLORS_CONFIG = {
  name: "colors", title: "Abanico de colores", subtitle: "colores en el catálogo de marcas", singular: "color",
  empty: { brand: "Sherwin-Williams", code: "", name: "", hex: "#0067B1", family: "Azules", order: 0 },
  numeric: ["order"],
  fields: [
    { key: "brand", label: "Marca", type: "select", options: [{ value: "Sherwin-Williams", label: "Sherwin-Williams" }, { value: "Killing", label: "Killing" }] },
    { key: "family", label: "Familia", type: "select", options: FAMILIES.map((f) => ({ value: f, label: f })) },
    { key: "code", label: "Código", required: true, placeholder: "SW 7005" },
    { key: "name", label: "Nombre", required: true, placeholder: "Pure White" },
    { key: "hex", label: "Color (HEX)", type: "color" },
    { key: "order", label: "Orden", type: "number" },
  ],
  columns: [
    { key: "hex", label: "", render: (it) => <span className="block w-10 h-10 rounded-lg border border-gray-200" style={{ background: it.hex }} /> },
    { key: "name", label: "Color", render: (it) => (<div><div className="font-semibold text-gray-900">{it.name}</div><div className="font-mono-code text-xs text-gray-400">{it.code} · {it.hex}</div></div>) },
    { key: "brand", label: "Marca", hide: true },
    { key: "family", label: "Familia", hide: true },
    { key: "order", label: "Orden", right: true },
  ],
};
